module.exports = __webpack_public_path__ + "static/media/halal.77cefc06.png";